/**
 * @param {{ rows?: number, disabled?: boolean, invalid?: boolean, style?: any, [key: string]: any }} props
 */
export default function Textarea({ rows = 3, disabled = false, invalid = false, className: callerClassName, style, ...rest }) {
  return (
    <textarea
      rows={rows}
      disabled={disabled}
      className={`ab-textarea${callerClassName ? ' ' + callerClassName : ''}`}
      style={{
        width: '100%',
        padding: '8px 10px',
        fontSize: 'var(--ab-text-sm)',
        fontFamily: 'var(--ab-font-sans)',
        color: 'var(--ab-fg)',
        background: disabled ? 'var(--ab-bg-input)' : 'var(--ab-bg)',
        border: invalid ? '1.5px solid var(--ab-denied)' : '1px solid var(--ab-fg)',
        borderRadius: 'var(--ab-radius-sm)',
        outline: 'none',
        resize: 'vertical',
        ...style,
      }}
      {...rest}
    />
  );
}
